module.exports = __webpack_public_path__ + "img/08.26b9efb3.png";